import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { serviceList } from '../../../mocks/products';

const serviceImages: Record<string, string> = {
  cex: 'http://geel.fp.08wx.cn/images/bcf032129c5416312b3ded18f265442f.jpg',
  wallet: 'http://geel.fp.08wx.cn/images/c484e5cce0a4bc9ade33f0730ba43e96.jpg',
  rwa: 'http://geel.fp.08wx.cn/images/43e4e3f30500f09dc3bc7075227a5774.jpg',
  dapp: 'http://geel.fp.08wx.cn/images/21147e0bf890cf9fe9507eda1e7badf8.jpg',
};

export default function ServicesSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-[#FFF8FB] py-24 relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />

      <div className="max-w-[1400px] mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-5 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
            <i className="ri-apps-2-line text-primary text-sm" />
            <span className="text-primary text-xs font-medium uppercase tracking-wider">{t('services.tag')}</span>
          </div>
          <h2 className="text-4xl xl:text-5xl font-heading font-bold text-gray-900">{t('services.title')}</h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {serviceList.map((service) => (
            <div
              key={service.id}
              className="group bg-white border border-primary-100 rounded-2xl overflow-hidden card-glow transition-all duration-300 hover:-translate-y-1"
            >
              {/* Image */}
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={serviceImages[service.id]}
                  alt={t(service.titleKey)}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-white via-white/10 to-transparent" />
                {/* Icon badge */}
                <div
                  className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center rounded-xl"
                  style={{ backgroundColor: `${service.color}20`, border: `1px solid ${service.color}40` }}
                >
                  <i className={`${service.icon} text-lg`} style={{ color: service.color }} />
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-heading font-bold text-gray-900 mb-3">{t(service.titleKey)}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{t(service.descKey)}</p>

                {/* Tags */}
                <div className="flex flex-wrap gap-2 mb-5">
                  {service.features.map((fk, fi) => (
                    <span
                      key={fi}
                      className="px-3 py-1 text-xs rounded-full border"
                      style={{
                        color: service.color,
                        borderColor: `${service.color}30`,
                        backgroundColor: `${service.color}10`,
                      }}
                    >
                      {t(fk)}
                    </span>
                  ))}
                </div>

                <Link
                  to={service.path}
                  className="inline-flex items-center gap-1.5 text-sm font-medium transition-colors cursor-pointer"
                  style={{ color: service.color }}
                >
                  {t('services.more')}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
